import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/24/solid';
import { Fragment } from 'react/jsx-runtime';

export interface SelectOption {
  name?: string;
  value?: string;
}

interface Props {
  // biome-ignore lint/suspicious/noExplicitAny: Leaving this for backwards compatibility
  selectedValue: any;
  options: SelectOption[];
  onChange: (value: SelectOption) => void;
  placeholder: string;
}

const Select = ({ options, selectedValue, onChange, placeholder }: Props) => {
  return (
    <Listbox value={selectedValue} onChange={onChange}>
      <div className="relative mt-1">
        <Listbox.Button className="relative w-full cursor-default rounded-lg border border-[#E5E7EB] bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
          <span className="block truncate">{selectedValue.name || placeholder}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-sm ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {options.map((option, index) => {
              const isSelected = selectedValue?.value === option.value;
              return (
                <Listbox.Option
                  // biome-ignore lint/suspicious/noArrayIndexKey: Keeping this for backwards compatibility
                  key={index}
                  className={({ active }) =>
                    `relative cursor-default select-none px-2 py-2 text-[#111827] ${active && 'bg-[#E5E7EB]'}`
                  }
                  value={option}
                >
                  <div
                    className={`flex flex-row items-center gap-x-2 truncate ${
                      isSelected ? 'font-medium' : 'font-normal'
                    }`}
                  >
                    {isSelected ? <CheckIcon className="h-4 w-4" aria-hidden="true" /> : null}
                    {option.name}
                  </div>
                </Listbox.Option>
              );
            })}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default Select;
